<template>
  <v-dialog :value="isFilesSending || showDialog" persistent width="600">
    <v-card color="white" class="pt-4">
      <v-card-text class="text-center">
        {{isFilesSending ? 'Идет загрузка файлов. Пожалуйста, подождите...' : 'Отправка файлов на сервер завершена.'}}
        <v-progress-linear v-if="isFilesSending" indeterminate color="primary" class="mt-4"></v-progress-linear>
        <div v-for="(file, index) in pendingFiles" :key="file.id+file.name+index" class="d-flex justify-space-between mt-3 mx-9">
          <div class="d-flex align-center">
            <FileBadge small :noName="true" :closable="false" :name="file.name" class="mr-1" />
            <span class="file-name">{{file.name}}</span>
          </div>
          <div>
            <v-progress-circular v-if="file.sending" indeterminate color="primary" size="20" class="absolute spinner" />
            <v-icon v-else-if="file.error" small color="red">mdi-alert-circle</v-icon>
            <v-icon v-else-if="file.sended" small color="green" >mdi-check-circle</v-icon>
          </div>
        </div>
        <div class="mt-4 d-flex justify-center">
          <v-btn color="primary" @click="onCancelSendingFiles()">{{ isFilesSending ? 'Прервать' : 'Закрыть'}}</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
/* eslint-disable */

import { mapActions, mapGetters, mapMutations } from 'vuex';
import FileBadge from '@/components/ui/FileBadge.vue'

export default {
  name: 'Analytics',
  components: {
    FileBadge
  },
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      pendingFiles: 'ai/dossier/pendingFiles',
      isFilesSending: 'ai/dossier/isFilesSending',
    }),
  },
  watch: {
    isFilesSending(val) {
      if (val) {
        this.showDialog = true;
      } 
    }
  },
  methods: {
    ...mapActions({
    }),
    ...mapMutations({
      setCancelSendingFiles: 'ai/expert/setCancelSendingFiles',
      setPendingFiles: 'ai/dossier/setPendingFiles',
    }),
    onCancelSendingFiles() {
      if (this.isFilesSending) {
        this.setCancelSendingFiles(true);
        this.showDialog = false;
      } else {
        this.showDialog = false;
      }
      this.setPendingFiles([]);
    }
  },
  async mounted() {
  },
  beforeDestroy() {}
};
</script>

<style scoped lang="scss">

.file-name {
  max-width: 420px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  padding-top: 4px;
}


</style>
